"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedAdsManager = void 0;
var AdsManager_1 = require("../AdsManager");
var CombinedAdsManager = (function (_super) {
    __extends(CombinedAdsManager, _super);
    function CombinedAdsManager(logger) {
        var _this = _super.call(this) || this;
        _this.managers = [];
        _this.detachedLoading = false;
        _this.selectedManager = null;
        _this.logger = logger;
        return _this;
    }
    CombinedAdsManager.prototype.register = function (manager) {
        this.managers.push(manager);
    };
    CombinedAdsManager.prototype.canLoad = function (source, metadata) {
        return this.managers.some(function (manager) {
            return manager.canLoad(source, metadata);
        });
    };
    CombinedAdsManager.prototype.load = function (source, metadata) {
        this.source = source;
        this.selectedManager = this.managers.find(function (manager) {
            return manager.canLoad(source, metadata);
        });
        if (!this.selectedManager)
            return Promise.resolve(source);
        return this.selectedManager.load(source, metadata);
    };
    CombinedAdsManager.prototype.seek = function (activeSeek) {
        if (!this.selectedManager)
            return {};
        return this.selectedManager.seek(activeSeek);
    };
    CombinedAdsManager.prototype.setMetadata = function (sourceMetadata) {
        var _this = this;
        if (this.selectedManager) {
            this.selectedManager.setMetadata(sourceMetadata);
        }
        else if (this.detachedLoading) {
            this.detachedMetadataUpdate = sourceMetadata;
        }
        else if (this.source) {
            var newManager = this.managers.find(function (manager) {
                return manager.canLoad(_this.source, sourceMetadata);
            });
            if (newManager) {
                return this.loadDetached(newManager, sourceMetadata);
            }
        }
        return Promise.resolve(undefined);
    };
    CombinedAdsManager.prototype.loadDetached = function (newManager, sourceMetadata) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.detachedLoading = true;
                        return [4, newManager.load(this.source, sourceMetadata)];
                    case 1:
                        _b.sent();
                        if (this.detachedMetadataUpdate) {
                            newManager.setMetadata(this.detachedMetadataUpdate);
                        }
                        this.selectedManager = newManager;
                        return [3, 4];
                    case 2:
                        error_1 = _b.sent();
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn('Failed to initialize ads manager on the fly', error_1);
                        return [3, 4];
                    case 3:
                        this.detachedMetadataUpdate = undefined;
                        this.detachedLoading = false;
                        return [7];
                    case 4: return [2];
                }
            });
        });
    };
    CombinedAdsManager.prototype.getMediaTime = function (contentTime) {
        if (!this.selectedManager)
            return contentTime;
        return this.selectedManager.getMediaTime(contentTime);
    };
    CombinedAdsManager.prototype.getContentTime = function (mediaTime) {
        if (!this.selectedManager)
            return mediaTime;
        return this.selectedManager.getContentTime(mediaTime);
    };
    Object.defineProperty(CombinedAdsManager.prototype, "timelineEvents", {
        get: function () {
            if (!this.selectedManager)
                return [];
            return this.selectedManager.timelineEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "isPlayingClientSide", {
        get: function () {
            if (!this.selectedManager)
                return false;
            return this.selectedManager.isPlayingClientSide;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "muted", {
        get: function () {
            if (!this.selectedManager)
                return false;
            return this.selectedManager.muted;
        },
        set: function (muted) {
            if (!this.selectedManager)
                return;
            this.selectedManager.muted = muted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "volume", {
        get: function () {
            if (!this.selectedManager)
                return 1;
            return this.selectedManager.volume;
        },
        set: function (volume) {
            if (!this.selectedManager)
                return;
            this.selectedManager.volume = volume;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "paused", {
        get: function () {
            if (!this.selectedManager)
                return false;
            return this.selectedManager.paused;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "currentTime", {
        get: function () {
            if (!this.selectedManager)
                return 0;
            return this.selectedManager.currentTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "duration", {
        get: function () {
            if (!this.selectedManager)
                return 0;
            return this.selectedManager.duration;
        },
        enumerable: false,
        configurable: true
    });
    CombinedAdsManager.prototype.play = function () {
        if (!this.selectedManager)
            return;
        this.selectedManager.play();
    };
    CombinedAdsManager.prototype.pause = function () {
        if (!this.selectedManager)
            return;
        this.selectedManager.pause();
    };
    Object.defineProperty(CombinedAdsManager.prototype, "currentAdBreak", {
        get: function () {
            if (!this.selectedManager)
                return null;
            return this.selectedManager.currentAdBreak;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "currentAd", {
        get: function () {
            if (!this.selectedManager)
                return null;
            return this.selectedManager.currentAd;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "adBreaks", {
        get: function () {
            if (!this.selectedManager)
                return [];
            return this.selectedManager.adBreaks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombinedAdsManager.prototype, "canSkipAd", {
        get: function () {
            if (!this.selectedManager)
                return false;
            return this.selectedManager.canSkipAd;
        },
        enumerable: false,
        configurable: true
    });
    CombinedAdsManager.prototype.skipAd = function () {
        if (!this.selectedManager)
            return;
        this.selectedManager.skipAd();
    };
    CombinedAdsManager.prototype.unload = function () {
        if (!this.selectedManager)
            return;
        this.selectedManager.unload();
        this.selectedManager = null;
    };
    CombinedAdsManager.prototype.shouldPostponeInitialSeek = function () {
        if (!this.selectedManager)
            return false;
        return this.selectedManager.shouldPostponeInitialSeek();
    };
    return CombinedAdsManager;
}(AdsManager_1.AdsManager));
exports.CombinedAdsManager = CombinedAdsManager;
//# sourceMappingURL=index.js.map